// E.g. "4:05"
export const formatSecondsLeft = (secondsLeft: number) => {
  const minutes = Math.floor(secondsLeft / 60)
  const seconds = secondsLeft % 60

  return `${minutes}:${String(seconds).padStart(2, '0')}`
}
